<script>
import SubHeader from "@/components/SubHeader";
export default {
  components: {
    SubHeader,
  },
  data: () => ({
    headerProps: {
      title: "Gerenciar Linhas",
      btns: [
        {
          text: "Novo",
          color: "primary",
          action: () => {},
          icon: "mdi-plus",
          path: "/cadastros-operacionais/linhas/new",
          isRedirector: true,
        },
        {
          text: "Recarregar",
          color: "primary",
          action: () => {},
          icon: "mdi-update",
          path: "",
          isRedirector: false,
        },
      ],
    },
    search: "",
    headers: [
      { text: "Descrição", value: "descricao", sortable: false },
      { text: "Prefixo da Linha", value: "sigma", sortable: false },
      { text: "Prefixo SGP/SIGMA", value: "prefixo", sortable: false },
      { text: "Serviço", value: "servico", sortable: false },
      { text: "Orgão", value: "orgao", sortable: false },
      { text: "Modalidade", value: "modalidade", sortable: false },
      { text: "Categoria", value: "categoria", sortable: false },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
    items: [],
  }),
  created() {
    this.initialize();
    this.headerProps.btns[1].action = () => this.initialize();
  },
  methods: {
    handleSearch: function (value) {
      this.search = value;
    },
    initialize() {
      this.items = [];
      this.$store.dispatch("activeLoader", true);
      this.$http.get("/linhas").then((r) => {
        this.items = r.data ? r.data : [];
        this.$store.dispatch("activeLoader", false);
      });
    },
    editar(id) {
      this.$router.push(`/cadastros-operacionais/linhas/editar/${id}`);
    },
    deleteItem(id) {
      let c = confirm("Deseja apagar o registro?");
      if (c) {
        this.$store.dispatch("activeLoader", true);
        this.$http.post(`/linhas/delete/${id}`).then((r) => {
          this.$store.dispatch("activeLoader", false);
          alert(r.data.success);
          //  location.href = location.href;
          this.initialize();
        });
      }
    },
  },
};
</script>
